import React from 'react';
import { ArrowUpRight } from 'lucide-react';
import { doctorsCard, productsCard } from '../mock';
import { useLang } from '../i18n/LanguageContext';

const TransformNaturally = () => {
  const { t } = useLang();
  const cards = [doctorsCard, productsCard];
  return (
    <section className="py-24 md:py-32 bg-[#0B3D2E] relative">
      <div className="max-w-[1440px] mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="font-serif-display text-4xl md:text-6xl leading-tight">
            <span className="peach-text italic">{t('tn.title.italic')},</span>{' '}
            <span className="text-[#ffffff]">{t('tn.title')}</span>
          </h2>
          <p className="text-[#ffffff]/70 mt-6 max-w-2xl mx-auto">
            {t('tn.sub')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {cards.map((card, i) => (
            <div
              key={card.title}
              className={`rounded-3xl overflow-hidden relative card-hover min-h-[420px] flex flex-col justify-between p-10 ${
                i === 0 ? 'bg-[#f5ede2] text-[#0B3D2E]' : 'bg-[#e8c9b0] text-[#0B3D2E]'
              }`}
            >
              <div>
                <h3 className="font-serif-display text-4xl md:text-5xl mb-5 leading-tight">{t(`tn.card.${i}.title`, card.title)}</h3>
                <p className="text-[#0B3D2E]/75 text-lg max-w-sm">{t(`tn.card.${i}.desc`, card.description)}</p>
              </div>

              <div className="relative z-10 mt-8">
                <a
                  href="#learn"
                  className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-[#0B3D2E] text-[#ffffff] text-sm font-medium hover:bg-[#175C45] transition-colors"
                >
                  {t(`tn.card.${i}.cta`, card.cta)}
                  <ArrowUpRight className="w-4 h-4" />
                </a>
              </div>

              <img
                src={card.image}
                alt={card.title}
                className="absolute -right-12 bottom-0 w-[55%] h-[80%] object-cover rounded-tl-3xl opacity-95 pointer-events-none"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TransformNaturally;
